export const
  PROJECT_V1 = 'SYS' /* 'SYS' */, // SYS
  PROJECT_V2 = 'SEV', // SEV
  PROJECT_BMA = 'BMA', // BMA
  PROJECT_D2D = 'D2D';//D2D